export default __webpack_public_path__ + "static/media/2-5-4.238b42a2.jpg";